import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import Avalanche from "@/components/avalanche/Avalanche";
import DangerSign from "@/components/dangerSign/DangerSign";

Vue.use(Router);

export function createRouter(options = {}) {
  return new Router({
    ...options,
    routes: [
      {
        path: "/",
        name: "Home",
        component: Home,
      },
      {
        path: "/avalanche",
        name: "Avalanche",
        component: Avalanche,
      },
      {
        path: "/dangerSign",
        name: "DangerSign",
        component: DangerSign,
      },
    ],
  });
}
